const contentKeyToTitleMap = {
	AbandonCartModalContents: 'Abandon Cart?',
	AddAcronisModalContents: 'Switching to Acronis Backups',
	AcronisCancelConfirmationDialogContents: 'Cancel Acronis - Confirmation',
	AcronisCancelDialogContents: 'Cancel Acronis',
	CreateNewCartModalContents: 'Create New Cart?',
	HostnameSelectionDialog: 'Hostname Selection',
	PrivateParentNameDialog: 'Edit Private Parent Name',
	SwitchCartDialogContents: 'Switch Cart?',
	EditCartDetailsDialogContents: 'Edit Cart Details',
	FavoritesListDialogContents: 'Favorites',
};

const contentKeyToAddPadding = {
	DetourDialogContent: true,
	CreateAdminCartDialogContents: true,
	EditCartDetailsDialogContents: true,
	SwitchCartDialogContents: true,
	OpportunityModalContents: true,
};

const contentKeyButtonPadding = {};

const contentKeyToColor = {
	DeleteDNSZoneDialogContents2: 'danger',
};

export {
	contentKeyToTitleMap,
	contentKeyToColor,
	contentKeyToAddPadding,
	contentKeyButtonPadding,
};
